import React from 'react';
import { Container } from 'react-bootstrap';

const Projects = () => {
  return (
    <main>
      <section className='hero'>
        <Container>
          <h1>Projects</h1>
        </Container>
      </section>
      <section className='section-steel-blue'></section>
    </main>
  );
};

export default Projects;
